import { ReactComponent as SvgComponent } from './svg/decorative-tag.svg'

type SvgProps = React.ComponentProps<typeof SvgComponent>

export const DecorativeTag: React.FC<SvgProps> = (props) => (
  <SvgComponent {...props} />
)
